import { appName } from "../../statics/main";
import { version } from "process";

export class CommonService {
    public appName = appName;
    
    public setTitle = (title: string) => {
        document.title = `${this.appName} ${title ? '|' : ''} ${title} ${version}`
    }
}